<script setup lang="ts">
import type { Cluster } from '@/services/types/api.types';

const props = defineProps<{
  modelValue: boolean;
  sourceTheme: Cluster | null;
  themeOptions: { label: string; value: string }[];
  selectedTheme: string | null;
}>();

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void;
  (e: 'update:selectedTheme', value: string | null): void;
  (e: 'confirm'): void;
}>();

function close() {
  emit('update:modelValue', false);
}

function confirm() {
  emit('confirm');
}
</script>

<template>
  <q-dialog :model-value="modelValue" @update:model-value="emit('update:modelValue', $event)" @hide="close">
    <q-card style="min-width: 360px">
      <q-card-section class="text-h6">
        {{ $t('consultation.ai.mergeThemes.dialogTitle') }}
      </q-card-section>
      <q-card-section>
        <i18n-t
          v-if="sourceTheme"
          keypath="consultation.ai.mergeThemes.dialogMessage"
          tag="div"
          class="text-body2 q-mb-sm"
        >
          <template #source>
            <span class="text-weight-bold">{{ sourceTheme.theme }}</span>
          </template>
        </i18n-t>
        <q-select
          :model-value="selectedTheme"
          :options="themeOptions"
          :label="$t('consultation.ai.mergeThemes.selectLabel')"
          dense
          outlined
          emit-value
          map-options
          @update:model-value="emit('update:selectedTheme', $event)"
        />
      </q-card-section>
      <q-card-actions align="right">
        <q-btn flat color="primary" :label="$t('global.cancel')" @click="close" />
        <q-btn
          color="primary"
          :label="$t('consultation.ai.mergeThemes.confirm')"
          :disable="!selectedTheme"
          @click="confirm"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>
